<template>
  <div>
    <pass-card-type-picker :value="passCardType" @input="onChangeType"/>

    <vg-pull-refresh-list empty-text="暂无验真记录"
                          ref="list"
                          :onLoadPage="onLoadPage"
                          @loaded="items => records = items"
                          v-slot="{items}">
      <vg-card v-for="record in items" :key="record.id">
        <div class="item" @click="toDetail(record)">
          <div class="item-content">
            <div class="item-entry" style="margin-top: 0px;">
              <div class="item-title">验真时间：</div>
              <div class="item-text">{{ record.verifyTime }}</div>
            </div>
            <div class="item-entry" v-if="!isGoodsInOut(record.passCardType)">
              <div class="item-title">姓名：</div>
              <div class="item-text">{{ record.name }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">租户公司：</div>
              <div class="item-text">{{ record.tenantName }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">出入证类型：</div>
              <div class="item-text">{{ getPassCardTypeStr(record.passCardType) }}</div>
            </div>
            <div class="item-entry">
              <div class="item-title">验真结果：</div>
              <div class="item-text" :style="isPass(record.verifyResult)?'':'color:#DC3C27'">
                {{ getResultStr(record.verifyResult) }}
              </div>
            </div>
          </div>
          <div class="item-arrow"/>
        </div>
      </vg-card>
    </vg-pull-refresh-list>
  </div>

</template>

<script>
import defaultPicture from "@/assets/myElectronicPass/defaultPicture.png";
import VgPullRefreshList from "@/components/Commons/VgPullRefreshList";
import VgCard from "@/components/Commons/VgCard";
import {client} from "@/libraries/http";
import PassCardTypePicker from "@/views/Common/PassCardTypePicker";

export default {
  name: "VerifyRecord",
  components: {
    PassCardTypePicker,
    VgPullRefreshList, VgCard
  },
  data() {
    return {
      records: [],
      defaultPicture,
      passCardType: undefined,
    }
  },
  methods: {
    onLoadPage({page, size}) {
      console.log(page + ", " + size);
      return client.get("/api/h5/guard/verify/page" + "?passCardType=" + this.passCardType + "&page=" + page + "&size=" + size)
          .then(res => {
            console.log(res);
            return {
              models: res.data.content,
              finished: res.data.content.length < size,
            };
          })
    },
    getResultStr(result) {
      return result === "PASS" ? "通过" : "不通过";
    },
    isPass(result) {
      return result === "PASS";
    },
    onChangeType(value) {
      console.log(value);
      this.passCardType = value;
      this.$refs.list.onRefresh();
    },
    getPassCardTypeStr(type) {
      if (type === 'CONSTRUCTION_SERVICE_PROVIDER') {
        return '物业服务商施工';
      } else if (type === 'CONSTRUCTION_DECORATION') {
        return '装修单元施工';
      } else if (type === 'CONSTRUCTION_OPERATIONS') {
        return '营运单元施工';
      } else if (type === 'TENANT_EMPLOYEE') {
        return '租户员工';
      } else if (type === 'GOODS_IN_OUT') {
        return '货品进出单';
      }
    },
    isGoodsInOut(type) {
      return type === 'GOODS_IN_OUT';
    },
    toDetail(record) {
      if (this.isGoodsInOut(record.passCardType)) {
        this.$router.push({path: '/scanVerify/verifyGoodsInOutDetail', query: {id: record.id}});
      } else {
        this.$router.push({path: '/scanVerify/verifyRecordDetail', query: {id: record.id}});
      }
    },
  },

}
</script>

<style scoped>
.item {
  width: auto;
  padding: 15px;
  background-repeat: no-repeat;
  background-position: bottom right 39px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item-content {
}

.item-entry {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 95px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #000000;
}

.item-arrow {
  margin-left: 15px;
  float: right;
  height: 20px;
  width: 20px;
  background-image: url("@/assets/right_arrow.svg");
}

</style>
